module.exports = __webpack_public_path__ + "img/jaeger.e0f92386.svg";